// Parses coordinates out of a pasted Google Maps link, so a customer can share a
// pin instead of hunting for the place by name.
export function parseCoordsFromLink(raw) {
  const text = String(raw || '')

  const at = text.match(/@(-?\d+(?:\.\d+)?),(-?\d+(?:\.\d+)?)/)
  if (at) return { lat: parseFloat(at[1]), lng: parseFloat(at[2]) }

  const query = text.match(/[?&](?:q|query|destination)=(-?\d+(?:\.\d+)?),(-?\d+(?:\.\d+)?)/)
  if (query) return { lat: parseFloat(query[1]), lng: parseFloat(query[2]) }

  const bare = text.match(/^\s*(-?\d+(?:\.\d+)?)\s*,\s*(-?\d+(?:\.\d+)?)\s*$/)
  if (bare) return { lat: parseFloat(bare[1]), lng: parseFloat(bare[2]) }

  return null
}

const PESO = new Intl.NumberFormat('en-PH', { style: 'currency', currency: 'PHP' })

export const peso = (amount) => (amount == null ? '—' : PESO.format(amount))

export const dateTime = (value) =>
  value == null
    ? '—'
    : new Date(value).toLocaleString('en-PH', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
      })

// +639175550142 → +63 917 555 0142, 09175550142 → 0917 555 0142. Anything that
// is not a Philippine mobile number is handed back untouched rather than
// mangled into a shape it was never in.
export const phone = (value) => {
  const raw = String(value || '').trim()
  const digits = raw.replace(/[^\d+]/g, '')

  const international = digits.match(/^\+63(\d{3})(\d{3})(\d{4})$/)
  if (international) return `+63 ${international[1]} ${international[2]} ${international[3]}`

  const local = digits.match(/^(0\d{3})(\d{3})(\d{4})$/)
  if (local) return `${local[1]} ${local[2]} ${local[3]}`

  return raw || '—'
}

// A dropped pin, in tabular figures so a column of them lines up. Five decimals
// is roughly a metre, which is as precise as a rider needs.
export const coords = (lat, lng) =>
  lat == null || lng == null ? '—' : `${lat.toFixed(5)}, ${lng.toFixed(5)}`

export const dateOnly = (value) =>
  value == null
    ? '—'
    : new Date(value).toLocaleDateString('en-PH', { day: 'numeric', month: 'short', year: 'numeric' })

/**
 * The clock time alone, for a thing that happened today and recently.
 *
 * Used for "as of 3:42 PM" under the rider's pin. No date, because the only reason to
 * print this is a position from the last few minutes — and a date beside it would make a
 * three-minute-old pin read as a filing rather than as a live thing that has paused.
 */
export const timeOnly = (value) =>
  value == null
    ? null
    : new Date(Number(value)).toLocaleTimeString('en-PH', { hour: 'numeric', minute: '2-digit' })
